import React from 'react';
import Sidebar from '../learnSidebar';
import NavbarLearn from '../navbarLearn';
import useDocumentTitle from '../useDocumentTitle'

export default function Four() {
    useDocumentTitle("Chapter 4 | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">04</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">MECHANICAL BASICS</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">BUILD RESPONSIBLY</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">CHAPTER OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Robot Cadded already? Here's how to build it.</p>
                        <p class="font-productsans text-base text-black mt-5">This chapter goes over some important things to know when building your robot, as well as common FRC parts/tools. Check out the topics below:</p>
                        <a href="/learn/four">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 4</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">MECHANICAL BASICS</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/a">Tools and Machinery</a>
                                    <p class="font-productsans font-normal ml-3">Learn about common tools in your workshop and how to use them safely.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/b">Tool Size Guide</a>
                                    <p class="font-productsans font-normal ml-3">A reference for sizing - it gets confusing sometimes!</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/c">Gears, Chains, and Belts</a>
                                    <p class="font-productsans font-normal ml-3">Understand how and when to use gears, chains, and belts.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/d">Motors</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the different FRC-legal motors.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/e">Drive Trains</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the most important part of your robot - without this, it's useless.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}